export default {
  name: 'marking--docUpdate',
};